module.exports = __webpack_public_path__ + "static/img/logo_txt_x2.68275a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_txt_x2.png
// module id = MhWi
// module chunks = 1